import FlagProvider from "@unleash/proxy-client-react";
import { ReactNode } from "react";
import { unleashConfig } from "./init";

export const FeatureFlagProvider = ({ children }: { children: ReactNode }) => {
  return <FlagProvider config={unleashConfig}>{children}</FlagProvider>;
};
